import { formatDate, isValidDate } from "@utils/dates";
import { dateColumn, genericColumn, primaryRelationshipColumn, roleColumn } from "./columnHelpers";
import { objectDefinition } from "./supportedObjects";

const {pluralName, color, endpoint} = objectDefinition('event');

export const eventsRelationship = {
    collapsible: true,
    title: pluralName,
    tint: color,
    type: 'table',
    columns: [
        primaryRelationshipColumn({endpoint}),
        genericColumn({
            label: 'Dates',
            visibleOnEdit: false,
            render: {
                show: (object) => {
                    return (<>
                        {object.dates.map((date, dateIndex) => (
                            <div key={dateIndex}>
                                {isValidDate(date.start_date) && (<span>{formatDate(date.start_date)}</span>)}
                                {isValidDate(date.start_date) && date.start_date != date.end_date && isValidDate(date.end_date) && (<>{' - '}</>)}
                                {date.start_date != date.end_date && isValidDate(date.end_date) && (<span>{formatDate(date.end_date)}</span>)}
                            </div>
                        ))}
                    </>);
                },
            },
        }),
    ],
};
